export const SENDER_TYPES = {
  BOT: 'bot',
  USER: 'user',
};
